import { Checkbox } from '@dunia/ui';
import * as conditions from '@/forms/conditions';

export default {
  name: 'CheckWrapper',
  functional: true,

  render(createElement, context) {
    const defaultValidations = [];

    if (context.props.optional === undefined) {
      defaultValidations.push(
        {
          errorMessage: 'Checkbox must be checked',
          condition: conditions.isCheckedCondition,
          name: 'is-checked',
        },
      );
    }

    return createElement(Checkbox, {
      defaultValidations,
      scopedSlots: {
        default: () => context.slots().default[0],
      },
    });
  },
};
